import React from "react";
import FreeAccessAnnouncement from "./FreeAccessAnnouncement";
import { isClubAdmin } from "../utility/Utils";
import { hasConfirmedDisabledBillingRollout } from "../pages/Billing/billingAccessPolicy";

export default function ClubFreeAccessAnnouncement({ user, billingState }) {
  if (
    !isClubAdmin(user) ||
    !user?._id ||
    billingState?.loading ||
    !hasConfirmedDisabledBillingRollout(billingState, user?.club?._id)
  )
    return null;

  return <FreeAccessAnnouncement dismissible userId={user._id} />;
}
